import QuestionNode from "./QuestionNode";

export default class QuestionList {
    constructor(answerFilterFn = null) {
        this.head = null;
        this.tail = null;
        this.length = 0;
        this.answerFilterFn = answerFilterFn;
    }

    push(question) {
        const newNode = new QuestionNode(question, this.answerFilterFn);
        if (!this.head) {
            this.head = newNode;
            this.tail = newNode;
        } else {
            this.tail.next = newNode;
            newNode.prev = this.tail;
            this.tail = newNode;
        }
        this.length++;
        return this;
    }

    pop() {
        //in case of empty list
        if (this.length === 0) {
            return false;
        }
        //get popped node
        const popped = this.tail;
        //save newTail to a variable (could be null)
        const newTail = this.tail.prev;
        //if newTail is not null
        if (newTail) {
            //sever connection to popped node
            newTail.next = null;
            //sever connection from popped node
            this.tail.prev = null;
            //in case of 1 length list
        } else {
            //make sure to edit head in case newTail is null
            this.head = null;
        }
        //assign new tail (could be null)
        this.tail = newTail;
        // subtract length
        this.length--;

        return popped;
    }

    shift() {
        //in case list is empty
        if (!this.head) {
            return false;
        }
        //save shifted node to variable
        const shiftedNode = this.head;
        //make the new head the next (might be null)
        const newHead = this.head.next; //might be null
        //if list is more than 1
        if (this.head !== this.tail) {
            newHead.prev = null;
            shiftedNode.next = null;
        } else {
            this.tail = null;
        }
        this.head = newHead;
        this.length--;
        return shiftedNode;
    }

    unshift(question) {
        const newNode = new QuestionNode(question, this.answerFilterFn);
        if (!this.head) {
            this.head = newNode;
            this.tail = newNode;
        } else {
            this.head.prev = newNode;
            newNode.next = this.head;
            this.head = newNode;
        }
        this.length++;
        return this;
    }

    insertAtIndex(index, question) {
        //if index doesn't exist
        if (index > this.length) {
            return false;
        }
        if (index === 0) {
            this.unshift(question, this.answerFilterFn);
        } else if (index === this.length) {
            this.push(question, this.answerFilterFn);
        } else {
            const newNode = new QuestionNode(question, this.answerFilterFn);
            const after = this.getNodeAtIndex(index);
            const before = after.prev;
            after.prev = newNode;
            before.next = newNode;
            newNode.next = after;
            newNode.prev = before;
            this.length++;
        }
        return this;
    }

    removeAtIndex(index) {
        let removedNode;
        if (index >= this.length) {
            return false;
        }
        if (index === 0) {
            removedNode = this.shift();
        } else if (index === this.length - 1) {
            removedNode = this.pop();
        } else {
            removedNode = this.getNodeAtIndex(index);
            const after = removedNode.next;
            const before = removedNode.prev;
            removedNode.next = null;
            removedNode.prev = null;
            before.next = after;
            after.prev = before;
            this.length--;
        }
        return removedNode;
    }

    getNodeByQuestionId(id) {
        id = id.toString();
        let node = this.getNodeAtIndex(0);
        do {
            if (node.question.getId() === id) {
                return node;
            }
            node = node.getNext();
        }
        while (node !== null)
        return null;
    }

    getNodeAtIndex(index) {
        if (index >= this.length || index < 0) {
            return false;
        }
        let currentIndex = 0;
        let currentNode = this.head;
        while (currentIndex !== index) {
            currentNode = currentNode.next;
            currentIndex++;
        }
        return currentNode;
    }

    setNodeAtIndex(index, question) {
        const foundNode = this.getNodeAtIndex(index)
        if(foundNode){
            foundNode.question = question;
            return foundNode;
        }
        return null;
    }

    getAllResults() {
        const allResults = [];
        let node = this.getNodeAtIndex(0);
        do {
            const results = node.getResults();
            if (results.length > 0) {
                allResults.push({
                   id: node.getQuestion().getId(),
                   results: results
                });
            }
            node = node.getNext();
        }
        while (node !== null)
        return allResults;
    }

    clearAllResults() {
        let node = this.getNodeAtIndex(0);
        do {
            node.clearResults();
            node = node.getNext();
        }
        while (node !== null)
    }
}